import { Label } from "@mui/icons-material";
import { SSO_ROLE_CONSTANT } from "../Mangement/modal/CreateAndEditNotify/FormDataConstants";

export const CUserRoles = [
  { key: SSO_ROLE_CONSTANT.admin, Label: "PCG Admin" },
  { key: SSO_ROLE_CONSTANT.broadCast, Label: "PCG BroadCast Manager" },
];
